'use client'

import { YoutubeListType } from "@/type/list"
import api from "@/util/api"
import { useContext, useEffect, useRef, useState } from "react"

import tumb_0 from "@/public/image/etc/live_banner.png"
import tumb_1 from "@/public/image/etc/live_baseball.png"
import tumb_2 from "@/public/image/etc/live_baseball2.png"
import tumb_3 from "@/public/image/etc/live_basketball.png"
import SectionTitle from "@/components/etc/section_title"
import { NavContext } from "@/context/navContext"
import moment from "moment"
import Slider from "@/components/common/swiper2"
import { SwiperSlide } from "swiper/react"
import { useTranslations } from "next-intl"

export default function SportsLiveRanding() {
    const [liveList, setLiveList] = useState<YoutubeListType[]>([])
    const listRef = useRef<HTMLUListElement>(null)

    const p = useTranslations("PageTitle")

    function fetchData() {
        const apiUrl = `/api/youtube/highlight/?page=1&count=5`
        api(apiUrl)
            .then(res => res.json())
            .then(({ data }) => {
                // const liveFilter = data.live.filter((el: YoutubeListType) => el.states == 'ING' && el.video != '').slice(0, 6)

                const liveFilter = data?.youtube_list ?? []
                if(Array.isArray(liveFilter)){
                    setLiveList(liveFilter)
                }
            })
    }

    useEffect(() => {
        fetchData()
    }, [])
    useEffect(() => {
        const len = liveList.length
        listRef.current?.style.setProperty('--wrap-width', `${(len * 158) + ((len - 1) * 11)}px`)
    }, [liveList])

    return (
        <div className="">
            <SectionTitle shortCut={`/youtube/highlight/`} type="youtube" >{p.rich("스포츠 b:하이라이트", { b: (c)=> <b>{c}</b> })}</SectionTitle>

            <div className="SlideList">
                <Slider titleUrl="/livebroadcast/">
                    {
                        !liveList.length
                            ? liveList.map((_, index) => (
                                <SwiperSlide key={index} style={{ width: "160px" }}>
                                    <SlideItemsPlaceHolder />
                                </SwiperSlide>
                            ))
                            : liveList.map((li, index) => (
                                <SwiperSlide key={index} style={{ width: "160px" }}>
                                    <SlideItems li={li} />
                                </SwiperSlide>
                            ))
                    }
                </Slider>
            </div>
        </div>
    )
}

function SlideItems({ li }: { li: YoutubeListType }) {
    const { movePage } = useContext(NavContext)
    return (
        <div className={'customList'}
            onClick={e => movePage(`/youtube/highlight/?id=${li.video_id}`)}>
            <div>
                <div className={`tumbnail`}>
                    {
                        li.thumbnail
                            ? <img src={li.thumbnail} alt={li.league_info} />
                            : <div className="empty-thumnail">{li.title}</div>
                    }
                </div>
                <div className="league-name">{li.title}</div>
                <div className="teams">
                    <div>
                        <span className="ha home"></span>
                        <p>{li.hometeam_name}</p>
                        <p>{li.hometeam_score}</p>
                    </div>
                    <div>
                        <span className="ha away"></span>
                        <p>{li.awayteam_name}</p>
                        <p>{li.awayteam_score}</p>
                    </div>
                    <div>
                        <p>{li.league_info}</p>
                    </div>
                    <div>
                        <p>{li.hometeam_name} VS {li.awayteam_name}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
function SlideItemsPlaceHolder() {
    return (
        <div className={'customList empty'} >
            <div>
                <div className={`tumbnail`}>
                    <div className="empty-thumnail placeholder-space"></div>
                </div>
                <div className="league-name">
                    <p className="placeholder-space"></p>
                </div>
                <div className="teams">
                    <div>
                        <span className="ha home"></span>
                        <p className="placeholder-space"></p>
                    </div>
                    <div>
                        <span className="ha away"></span>
                        <p className="placeholder-space"></p>
                    </div>
                    <div>
                        <p className="placeholder-space"></p>
                    </div>
                    <div>
                        <p className="placeholder-space"></p>
                    </div>
                </div>
            </div>
        </div>
    )
}